import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
    {
        q: '¿Qué es exactamente esta misión?',
        a: 'Un programa integral de consultoría de internacionalización — no un viaje. Se estructura en 3 fases: preparación estratégica previa (diagnóstico, mercados prioritarios, agenda B2B pre-armada), ejecución en Madrid con acompañamiento diario, y seguimiento post-feria para convertir conversaciones en oportunidades reales. Los días de FITUR son la parte visible del programa — el trabajo real empieza antes y sigue mucho después.',
    },
    {
        q: '¿Por qué es la primera edición individual?',
        a: 'Incubatour lleva más de 25 años operando misiones a nivel corporativo (para gobiernos, gremios y grandes empresas). Esta es la primera vez que abrimos cupos individuales para dueños, gerentes y decisores de empresas turísticas medianas de LATAM. Por eso los cupos son limitados y hay una sesión de orientación previa: queremos que el grupo esté al nivel.',
    },
    {
        q: '¿Qué pasa en la sesión de orientación?',
        a: 'Son 30 minutos por videollamada con nuestro equipo. Evaluamos tu perfil, tu capacidad real de operar internacionalmente y definimos juntos objetivos gana-gana para la misión. Si hay match, activamos tu Fase 1 de inmediato. Si no, te dejamos recomendaciones concretas. Cualquier duda posterior la resolvemos por WhatsApp.',
    },
    {
        q: '¿Qué incluye y qué no incluye el precio?',
        a: 'Incluye: preparación estratégica completa, gestión de agenda B2B, registro FITUR + LiveConnect, acompañamiento en Madrid, cena de bienvenida y seguimiento post-feria. NO incluye: vuelos (para que uses tus millas), alojamiento, comidas no especificadas, seguro y gastos personales.',
    },
    {
        q: '¿Cuánto cuesta ir a FITUR con esta misión?',
        a: 'La inversión escala en 4 tramos: USD 1.500 (Lanzamiento, solo 8 cupos hasta el 30 de septiembre), USD 1.600 (Early Bird, hasta el 30 de octubre), USD 1.750 (Precio Regular, hasta el 30 de noviembre) y USD 2.200 (Last Call, hasta el 19 de diciembre). Impuestos incluidos. Reserva con USD 300 y el saldo en cuotas personalizadas, establecidas bajo contrato.',
    },
    {
        q: '¿Y si mi empresa aún no está lista?',
        a: 'La sesión de orientación sirve para eso. Somos honestos: si evaluamos que aún no es tu momento, te lo decimos y te damos un plan para que llegues listo a la próxima edición. No metemos empresas que no van a capitalizar.',
    },
    {
        q: '¿De qué países LATAM aceptan participantes?',
        a: 'De todos: Colombia, México, Perú, Chile, Argentina, Uruguay, Paraguay, Ecuador, Bolivia, Panamá, Costa Rica, Guatemala, El Salvador, Honduras, Nicaragua, Rep. Dominicana, Cuba, Puerto Rico, Venezuela y Brasil. La misión se opera en español.',
    },
];

const Item = ({ q, a, open, onToggle, i }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-40px' }}
        transition={{ duration: 0.5, delay: i * 0.04 }}
        className="border-b border-white/10"
    >
        <button
            onClick={onToggle}
            className="w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left group"
        >
            <span className="font-display text-white text-xl md:text-2xl leading-tight flex-1">
                {q}
            </span>
            <span
                className={`flex-shrink-0 h-9 w-9 rounded-full border flex items-center justify-center transition-all duration-300 ${
                    open ? 'bg-[color:var(--brand)] border-[color:var(--brand)] rotate-45' : 'border-white/25 group-hover:border-white'
                }`}
            >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
            </span>
        </button>
        <AnimatePresence initial={false}>
            {open && (
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                >
                    <div className="pb-6 md:pb-8 pr-14 text-white/75 leading-relaxed max-w-[80ch]">
                        {a}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    </motion.div>
);

const FAQ = () => {
    const [open, setOpen] = useState(0);

    return (
        <section id="faq" className="relative py-16 md:py-20 border-t border-white/10">
            <div className="mx-auto max-w-[1200px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-5 md:gap-8 mb-8">
                    <div className="col-span-12 md:col-span-5">
                        <div className="eyebrow-brand mb-6">Preguntas frecuentes</div>
                        <h2 className="font-display text-white text-4xl md:text-5xl">
                            Todo lo que <span className="italic-accent text-[color:var(--brand)] font-normal">necesitas</span> saber.
                        </h2>
                        <p className="mt-6 text-white/70 leading-relaxed">
                            Si tu duda no está aquí, escríbenos por WhatsApp: te contestamos en menos de 6 horas hábiles.
                        </p>
                    </div>
                    <div className="col-span-12 md:col-span-7">
                        {faqs.map((f, i) => (
                            <Item
                                key={i}
                                i={i}
                                q={f.q}
                                a={f.a}
                                open={open === i}
                                onToggle={() => setOpen(open === i ? -1 : i)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQ;
